import axios from 'axios'
import { ACCOUNT_SERVICE_USAGE_API_URL } from '@/env'

export type UsageMonthlyResponse = {
  accountId: string
  month: string
  items: any[]
  totals: Record<string, number>
}

export type UsageRangeResponse = {
  accountId: string
  startMonth: string
  endMonth: string
  months: string[]
  items: any[]
  totals: Record<string, number>
}

function baseUrl(): string {
  return String(ACCOUNT_SERVICE_USAGE_API_URL || '').replace(/\/+$/, '')
}

export async function fetchUsageMonthly(params: {
  accountId: string
  month: string
}): Promise<UsageMonthlyResponse> {
  const b = baseUrl()
  if (!b) throw new Error('account_service_usage_api_missing')

  const q = new URLSearchParams()
  q.set('accountId', String(params.accountId || '').trim())
  q.set('month', String(params.month || '').trim())

  const res = await axios.get(`${b}/usage/monthly?${q.toString()}`)
  return res.data as UsageMonthlyResponse
}

export async function fetchUsageRange(params: {
  accountId: string
  startMonth: string
  endMonth: string
}): Promise<UsageRangeResponse> {
  const b = baseUrl()
  if (!b) throw new Error('account_service_usage_api_missing')

  const q = new URLSearchParams()
  q.set('accountId', String(params.accountId || '').trim())
  q.set('startMonth', String(params.startMonth || '').trim())
  q.set('endMonth', String(params.endMonth || '').trim())

  const res = await axios.get(`${b}/usage/range?${q.toString()}`)
  return res.data as UsageRangeResponse
}

